import { Component, Input, OnInit } from '@angular/core';
import { AssetsService } from '../../../../services/assets.service';
import { Asset } from '../../../../model/asset';
import { Device } from '../../../../model/device';

@Component({
  selector: 'app-asset-devices',
  templateUrl: './asset-devices.component.html',
  styleUrls: ['./asset-devices.component.scss']
})
export class AssetDevicesComponent implements OnInit {

  @Input()
  public asset: Asset;

  public devices: Device[];
  public totalDevices: number;
  public loadingDevices: boolean;

  public rows = 10;
  public first = 0;

  constructor(private assetsService: AssetsService) {
  }

  ngOnInit(): void {
    this.loadDevices();
  }

  private loadDevices(): void {
    this.loadingDevices = true;
    this.devices = new Array(this.rows);
    this.assetsService.getAssetDevices(this.asset.uuid).toPromise().then(response => {
      this.devices = response.devices;
      this.totalDevices = response.totalElements;
      this.loadingDevices = false;
    });
  }

}
